import React from "react";
import DocumentTitle from "react-document-title";
import get from "lodash/get";

/*
 * Takes a `title` as input and returns a HOC that adds a `DocumentTitle`
 * wrapper with the given title. If `title` is a function, it will be
 * called with `this.props` to yield the title text.
 *
 * e.g. `withDocumentTitle("Integrations")(Integrations)` will set the
 * document title to "Integrations | AppOptics" and render `Integrations`.
 */
export const withDocumentTitle = title => {
  const titleFn = typeof title === "function" && title;
  return WrappedComponent => {
    class DocumentTitleWrapper extends React.Component {
      render() {
        const titleText = titleFn ? titleFn(this.props) : title;
        return (
          <DocumentTitle title={`${titleText || ""} | AppOptics`}>
            <WrappedComponent {...this.props} />
          </DocumentTitle>
        );
      }
    }

    return DocumentTitleWrapper;
  };
};

export const withServiceDocumentTitle = title =>
  withDocumentTitle(
    props => `${get(props, "match.params.service", "")} ${title}`
  );

export default withDocumentTitle;
